export default "__VITE_ASSET__eWwO0l3z__"